import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import Routes from './routes';
import Wrapper from './Wrapper';
import translations from './assets/locales.json';
import config from './config';
import { initExperiments } from './actions/abTestAction';
import { any } from 'prop-types';

[en, zh].forEach(locale => addLocaleData(locale));

class RootContainer extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    lang: PropTypes.oneOf(['en', 'zh']).isRequired,
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    initExperiments: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { history, lang } = this.props;
    // window.addEventListener('message', (e) => {
    //   try {
    //     const action = JSON.parse(e.data);
    //     if (action.type === 'route') {
    //       history.push(`/${lang}/${config.webview.identityFEPath}${action.route}`);
    //     } else if (action.type === '@EMMA_WEB/ACCESS_TOKEN') {
    //       sessionStorage.setItem('token', action.token);
    //     }
    //   // eslint-disable-next-line no-empty
    //   } catch (err) { }
    // }, false);

    history.listen((location) => {
      const parentWin = window.top;
      if (location.action === 'PUSH') {
        const baseUri = `${window.location.origin}/${lang}/${config.webview.myaxaPath}`;
        const href = window.location.href.replace(`${baseUri}`, '');

        const titleSpan = document.querySelector('h1.emma-header');

        const title = titleSpan ? titleSpan.innerHTML : '';
        const message = JSON.stringify({
          type: 'history',
          href,
          title,
        });
        // TODO: POST_MESSAGE - May post message to back to the parent page (same origin)
        parentWin && parentWin.postMessage(message, window.location.origin, []);
      } else if (location.action === 'POP') {
        const message = JSON.stringify({
          type: 'POP_HISTORY',
        });
        // TODO: POST_MESSAGE - May post message to back to the parent page (same origin)
        parentWin && parentWin.postMessage(message, window.location.origin, []);
      }
    });

    this.props.dispatch(initExperiments());
  }

  render() {
    const { store, lang, history, dispatch } = this.props;

    return (
      <Wrapper lang={lang} store={store} locales={translations}>
        <Routes history={history} dispatch={dispatch} />
      </Wrapper>
    );
  }
}

function mapStateToProps({ language }) {
  return {
    lang: language.lang,
  };
}

export default connect(mapStateToProps)(RootContainer);
